<script>
export default {
  data() {
    return {
      editing: false
    }
  },
  methods: {
    edit() {
      this.editing = true
    },
    done() {
      this.editing = false
    }
  },
  render() {
    return this.editing
      ? this.$scopedSlots.edit({ done: this.done })
      : this.$scopedSlots.default({ edit: this.edit })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/Editable.vue